import { useQuery } from '@tanstack/react-query'
import { getAvgCommissionsFetcher } from 'api/fetcher/ambassdor'

type useGetOrganizationListProps = {
    data: CommissionConfig
    isLoading: boolean
    isFetching: boolean
    error: any
    refetch: any
}

const useGetAvgCommissions = ({ programType, orgFeatType }: { programType: string, orgFeatType: string }): useGetOrganizationListProps => {
    const { data, error, isLoading, isFetching, refetch } = useQuery(
        ['avg-commissions', { programType: programType, orgFeatType: orgFeatType }],
        getAvgCommissionsFetcher,
        {
            retry: false,
            refetchOnWindowFocus: false,
            enabled: !!programType
        }
    )

    const avgCommission = new CommissionConfig(data?.data?.data || {})
    return {
        data: avgCommission,
        isLoading,
        error,
        isFetching,
        refetch,
    }
}

export default useGetAvgCommissions

export class CommissionConfig {
    avgNewStudentCommissionPerc: number
    avgNewStudentCeiling: number
    avgOldStudentCommissionPerc: number
    avgOldStudentCeiling: number
    avgCouponDiscountPerc: number
    avgCouponCeiling: number

    constructor(data: any) {
        this.avgNewStudentCommissionPerc = data.avgNewStudentCommissionPerc || 0
        this.avgNewStudentCeiling = data.avgNewStudentCeiling || 0
        this.avgOldStudentCommissionPerc = data.avgOldStudentCommissionPerc || 0
        this.avgOldStudentCeiling = data.avgOldStudentCeiling || 0
        this.avgCouponDiscountPerc = data.avgCouponDiscountPerc || 0
        this.avgCouponCeiling = data.avgCouponCeiling || 0
    }
}